import anestesikodModule from "@/store/modules/operation/anestesikodModule";
import anestesiModule from "@/store/modules/operation/anestesiModule";
import antibiotikaprofylaxModule from "@/store/modules/operation/antibiotikaprofylaxModule";
import blockadModule from "@/store/modules/operation/blockadModule";
import diabetesBehandlingsformModule from "@/store/modules/operation/diabetesBehandlingsformModule";
import kontaktorsakModule from "@/store/modules/operation/kontaktorsakModule";
import operationoversikt from "@/store/modules/operation/operationoversiktModule";
import operationsanmalan from "@/store/modules/operation/operationsanmalan.js";
import operationsanmalanModule from "@/store/modules/operation/operationsanmalanModule";
import operationsjournal from "@/store/modules/operation/operationsjournal.js";
import operationskalender from "@/store/modules/operation/operationskalender.js";
import operationskodModule from "@/store/modules/operation/operationskodModule";
import patientlageModule from "@/store/modules/operation/patientlageModule";
import preanestesibedomning from "@/store/modules/operation/preanestesibedomning.js";
import premedicineringModule from "@/store/modules/operation/premedicineringModule";
import rontgenModule from "@/store/modules/operation/rontgenModule";
import trombosprofylaxModule from "@/store/modules/operation/trombosprofylaxModule";
import typoperationer from "@/store/modules/operation/typoperationer.js";
import typoperationModule from "@/store/modules/operation/typoperationModule";
import vardformModule from "@/store/modules/operation/vardformModule";

export default {
    namespaced: true,
    modules: {
        typoperationer,
        operationoversikt,
        operationsanmalan,
        operationskalender,
        operationsjournal,
        preanestesibedomning,
        operationskod: operationskodModule,
        anestesikod: anestesikodModule,
        premedicinering: premedicineringModule,
        anestesi: anestesiModule,
        blockad: blockadModule,
        diabetesBehandlingsform: diabetesBehandlingsformModule,
        kontaktorsak: kontaktorsakModule,
        rontgen: rontgenModule,
        patientlage: patientlageModule,
        antibiotikaprofylax: antibiotikaprofylaxModule,
        trombosprofylax: trombosprofylaxModule,
        typoperation: typoperationModule,
        vardform: vardformModule,
        operationsanmalanV2: operationsanmalanModule,
    },
    mutations: {
        reset(state, { commit }) {
            const modules = state;

            Object.keys(modules).forEach((key) => {
                commit(`operation/${key}/reset`, { commit }, { root: true });
            });
        },
    },
};
